export const r = (e: Event) => {
    const target = e.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    const posMouseX = (e as MouseEvent).clientX - rect.left;
    const posMouseY = (e as MouseEvent).clientY - rect.top;
    const width = Math.max(rect.width, rect.height);
    const speed = target.dataset.rippleSpeed ? parseInt(target.dataset.rippleSpeed, 10) : 700;
    const color = target.dataset.rippleColor ?? "currentColor";

    // Note: Don't use logical properties to position.
    const baseCSS = [
        "position: absolute;",
        `inline-size: ${width * 2}px;`,
        `block-size: ${width * 2}px;`,
        `transition: all linear ${speed}ms;`,
        "transition-timing-function: cubic-bezier(0.250, 0.460, 0.450, 0.940);",
        "border-radius: 50%;",
        `background: ${color};`,
        `top: ${posMouseY - width}px;`,
        `left: ${posMouseX - width}px;`,
        "pointer-events: none;",
        "opacity: 0.6;",
        `transform: scale(0);`
    ].join("");

    const ripple = document.createElement("span");

    ripple.style.cssText = baseCSS;
    target.style.position = "relative";
    target.style.overflow = "hidden";
    target.appendChild(ripple);

    setTimeout(function () {
        ripple.style.cssText = baseCSS + "transform:scale(1); opacity: 0;";
    }, 5);

    setTimeout(function () {
        ripple.remove();
    }, speed);
};
document.querySelectorAll("[data-ripple]").forEach((rippleElem) => {
    rippleElem.addEventListener(`click`, r);
});
document.querySelectorAll("button:not(.link-text)").forEach((buttonElem) => {
    buttonElem.addEventListener(`click`, r);
});

export {};
